import { render, staticRenderFns } from "./EditGroupRoles.vue?vue&type=template&id=79d73305&scoped=true"
import script from "./EditGroupRoles.vue?vue&type=script&lang=js"
export * from "./EditGroupRoles.vue?vue&type=script&lang=js"
import style0 from "./EditGroupRoles.vue?vue&type=style&index=0&id=79d73305&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d73305",
  null
  
)

export default component.exports